import React, { useCallback, useEffect, useState } from "react";
import "./VirtualClassroom.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CommonCard from "../../../common/Pilots/CommonCard/CommonCard";
import { VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH } from "../../../../helper/APIPaths";
import { setsubCategoryNameOrItemName } from "../../../../storage/reducers/virtualClassRoomOrEngines";
import { COMMON_MESSAGES, VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS } from "../../../../helper/constants";
import CircularLoader from "../../../common/Loader/CircularLoader";
import { useTranslation } from "react-i18next";
import { isPilot } from "../../../../helper/commonFunctions";
import { setMenuSelection } from "../../../../storage/reducers/menuSelectorReducer";

const VirtualClassRoomDetail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { userInformation } = useSelector((state: any) => state?.userInformation);
  const { subCategoryNameVirtualClassrooms } = useSelector((state: any) => state?.virtualClassRoomsOrEngines);

  const [elements, setElements] = useState<Array<object>>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (elements.length === 0) {
      fetchVirtualClassroomElements();
    }
    dispatch(setMenuSelection({currentMenuTitle: subCategoryNameVirtualClassrooms}));
  }, [elements.length]);

  const fetchVirtualClassroomElements = useCallback(async () => {
    try {
      const { subCategory, pilot_category_name_VC } = VIRTUAL_CLASSROOMS_AND_ENGINES_API_PARAMS;
      const response = await fetch(VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: subCategory,
          pilot_category_name: pilot_category_name_VC,
          pilot_subcategory_name: subCategoryNameVirtualClassrooms || null,
          role: isPilot(userInformation?.jobTitle || ""),
        }),
      });
      const res = await response.json();
      const data = res?.data;
      if (data) {
        const sortedData = data?.preflightData.sort((a, b) => {
          if (a.id.toLowerCase() < b.id.toLowerCase()) return -1;
          if (a.id.toLowerCase() > b.id.toLowerCase()) return 1;
          return 0;
      });
        setElements(sortedData);
        setLoading(false);
        setError(false);
      }
    } catch (ierror) {
      console.error(
        "Error while fetching virtual classrooms data details",
        ierror
      );
      setLoading(false);
      setError(true);
    }
  }, []);

  const handleElementClick = (id: any) => {
    dispatch(setsubCategoryNameOrItemName({ itemName: id }));
    navigate(`/virtualclassroomsDetailList`);
  };

  const elementsList =
    elements.length > 0 &&
    elements?.map((element: any, index: number) => {
      const cardProps = {
        id: element?.id,
        title: `${element?.id} (${element?.value})`,
        type: "virtualclassrooms" as any,
        action: () => handleElementClick(element?.id),
      };
      return <CommonCard key={index} {...cardProps} />;
    });

  return (
    <div className="virtualClassroomContainer">
        {loading && <CircularLoader />}
        {elements.length > 0 &&
          <div className='virtualClassroomList'>
            {elementsList}
          </div>
        } 
        {(!loading && elements.length === 0) && (
          <div className='error'>{t(COMMON_MESSAGES.NO_RECORDS_FOUND)}</div>
        )}
        {error  && (
          <div className='error'>{t(COMMON_MESSAGES.NO_DATA_AVAILABLE)}</div>
        )}
    </div>
  );
};

export default VirtualClassRoomDetail;
